import { put, takeLatest } from "redux-saga/effects";
import { RequertRolesAllFailedAction, GetDataRolesAllSuccessAction } from "../actions";
import { GET_DATA_ROLES_ALL } from "../actions/actionTypes";
import { Api } from "./api";


function* GetDataRolesAll(){
    try{
        const DataRoles = yield Api.GetDataRolesAllFromApi();
        yield put(GetDataRolesAllSuccessAction(DataRoles));
    }
    catch(error){
        yield put(RequertRolesAllFailedAction(error));
    }
}

export function* watchGetDataRolesAll()
{
    yield takeLatest(GET_DATA_ROLES_ALL,GetDataRolesAll);
}